export const BaseUrl = () => {
  const host = window.location.hostname
  switch (host) {
    case 'marketplace.whatfix.com':
      return 'marketplaceimages.whatfix.com'
    default:
      return 'marketplaceimages.quickolabs.com'
  }
}
